import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import EN from "./translations/EN.json";
import ES from "./translations/ES.json";
import FR from "./translations/FR.json";

export const resources = {
    en: {
        translation: EN
    },
    es: {
        translation: ES
    },
    fr: {
        translation: FR
    }
};

i18next
    .use(LanguageDetector) // Use the browser language detector
    .use(initReactI18next) // Bind i18next to React
    .init({
        resources,
        // Verbose i18next console logging; enable with REACT_APP_I18N_DEBUG=true when debugging keys.
        debug: process.env.REACT_APP_I18N_DEBUG === "true",
        detection: {
            order: ["localStorage", "cookie", "navigator", "htmlTag"], // Prioritize localStorage
            caches: ["localStorage"], // Cache detected language in localStorage
        },
        fallbackLng: "en", // Fallback to English if no language is detected
        interpolation: {
            escapeValue: false // React already escapes values
        }
    });

export default i18next;

// Hot-reload translation bundles in development without a full page refresh
if (process.env.NODE_ENV === 'development' && (module as any).hot) {
    (module as any).hot.accept(
        ['./translations/EN.json', './translations/ES.json', './translations/FR.json'],
        () => {
            const newEN = require('./translations/EN.json');
            const newES = require('./translations/ES.json');
            const newFR = require('./translations/FR.json');
            i18next.addResourceBundle('en', 'translation', newEN, true, true);
            i18next.addResourceBundle('es', 'translation', newES, true, true);
            i18next.addResourceBundle('fr', 'translation', newFR, true, true);
        }
    );
}
